import { render, staticRenderFns } from "./desc-info.vue?vue&type=template&id=5b1daa20&scoped=true&"
import script from "./desc-info.vue?vue&type=script&lang=js&"
export * from "./desc-info.vue?vue&type=script&lang=js&"
import style0 from "./desc-info.vue?vue&type=style&index=0&id=5b1daa20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1daa20",
  null
  
)

export default component.exports